import React from "react";
import optionCallback from "./optionCallback";
import textConfig from "../utils/text";

/**
 * Frame 7
 * @param props
 * @constructor
 */

export default function Frame7(props: any){
	
	let {  Svg, svgProps, children, viewBox, backgroundColor, frameBody } = props;
	let { path, text_1 } = props;
	let [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1080 1400">
		<g><rect fill={frameBody} width="1080" height="1400" rx="40"/></g>
		<g transform={"translate(40,40)"}>
			<rect width="1000" height="1000" rx="20" fill={backgroundColor}/>
			{children}
		</g>
		<g transform={"translate(40,1128) scale(1)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs><clipPath id="myClip"><path d={path}/></clipPath></defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}